/* eslint-disable max-len */
import { Icon as MuiIcon, TableBody, TableHead, TableRow } from "@mui/material";
import Icon from "../../components/Icon";
import { useMemo, useState, useEffect, useContext } from "react";
import { useScreenClass } from "react-grid-system";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { CustomBlock, StyledImg } from "../../components/CompetenciesList";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import SearchCompetencies from "../../components/SearchCompetencies";
import TabGroup, { TabItem } from "../../components/TabGroup";
import { NullStateText, StyledText, TextSize } from "../../components/Text";
import theme from "../../styles/theme";
import { CompetencyType, EmptyCompetency } from "../../types/Competency";
import TableComponent, {
  StyledBodyCell,
  StyledHeaderCell,
  StyledTableRowNoHover,
} from "../../components/Table";
import ALink from "../../components/ALink";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import SnackBar from "../../components/SnackBar";
import CourseOverviewModify from "../../components/CourseOverviewModify";
import CourseSkillsModify from "../../components/CourseSkillsModify";
import axios from "axios";
import { VersionContext } from "../../context/VersionContext";
import LoadingSpinner from "../../components/LoadingSpinner";
import { UserContext } from "../../context/UserContext";

const Header = styled.h4`
  font-style: normal;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0px;
  text-align: left;
  color: ${theme.color.darkBlueGray900};
  margin-bottom: 0;
`;
const CustomFlex = styled(FlexBox)`
  padding: 10px 0;
  align-items: center;
  border-bottom: 3px solid ${theme.color.lightBlueGray100};
`;

const CustomGrow = styled(FlexGrow)`
  align-self: stretch;
  flex-grow: 0;
  // border-right: 3px solid  ${theme.color.lightBlueGray100};
`;

const Ul = styled.ul`
  color: ${theme.color.lightBlueGray500};
  padding-inline-start: 16px;
  margin-block-start: 0;
  margin-block-end: 0;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
`;
const LI = styled.li`
  color: ${theme.color.lightBlueGray500};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.20000000298023224px;
  text-align: left;
  vertical-align: text-top;
`;
const LiGradient = styled.li`
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.20000000298023224px;
  text-align: left;
  vertical-align: text-top;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  margin-bottom: 5px;
  text-decoration: underline;
`;

interface CourseColumn {
  id: "title" | "number" | "pillar" | "competencies";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}
const courseColumns: readonly CourseColumn[] = [
  { id: "title", label: "Course Title", minWidth: 200 },
  {
    id: "number",
    label: "Course Number",
    minWidth: 150,
  },
  { id: "pillar", label: "Pillar", minWidth: 80 },

  {
    id: "competencies",
    label: "Competencies",
    minWidth: 250,
  },
];
function ModifyCompetencyDetail(this: any) {
  const navigate = useNavigate();
  const { competencyCode } = useParams();
  const [tab, setTab] = useState(0);
  const screenClass = useScreenClass();
  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  const [navigatedCompetencies, setNavigatedCompetencies] = useLocalStorage(
    "competencies",
    []
  );
  const [dimensionError, setDimensionError] = useState<boolean>(false);
  const [descriptionCount, setDescriptionCount] = useState(0);
  const [image, setImage] = useState({ preview: "", raw: "" });

  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
  const [competency, setCompetency] = useState<CompetencyType>(EmptyCompetency);
  const [competencies, setCompetencies] = useState<Array<any>>([]);
  const [searchResult, setSearchResult] = useState<string>("");
  const [pageHeight, setPageHeight] = useState<string>("130px");
  const { version } = useContext(VersionContext);
  const [loading, setLoading] = useState<boolean>(false);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const { isModified, setModified, isOpen, setOpen } = useContext(UserContext);
  const [noDataMessage, setNoDataMessage] = useState("");

  const [legacyVersionsData, setLegacyVersionsData] = useState<any[]>([]);
  const [legacyConfirmOpen, setLegacyConfirmOpen] = useState(false);


  const universityCode = localStorage.getItem("university");
  const userContext = useContext(UserContext);
  const role = userContext.user.role;
  const roleId = userContext.user.id;

  const searchCompetency = (keyword: string) => {
    const found = filterArrayElementByCode(keyword);
    if (found && found.id) {
      setSearchResult(found.id);
    } else {
      setSnackbarOpen(true);
      setSearchResult("");
    }
  };
  useEffect(() => {
    if (version.version_number === 0) {
      navigate("/curriculum/version");
    }
    setTab(0);
    if (competencyCode) fetchCompetency(competencyCode);
    setImage({ preview: "", raw: "" });
    setNoDataMessage("");
    setDescriptionCount(0);
  }, [competencyCode]);
  const fetchCompetency = (id: any) => {
    let findCompetency = null;
    axios
      .get(
        `/competency/detail?competency_code=${id}&university_code=${universityCode}&curriculum_version=${version.version_number}`
      )
      .then((res) => {
        if (res.data.competency) {
          setCompetency(res.data.competency);
          findCompetency = res.data.competency;
        }
      })
      .catch((error: any) => {
        setLoading(false);
        if (error?.response?.data?.error) {
          setNoDataMessage(error?.response?.data?.error);
        } else {
          setNoDataMessage(
            `Competency with code ${id} does not exist in specificed curriculum version`
          );
        }
      });
    const url =
      role === "instructor"
        ? `/competency/summary?university_code=${universityCode}&curriculum_version=${version.version_number}&instructor_id=${roleId}`
        : `/competency/summary?university_code=${universityCode}&curriculum_version=${version.version_number}`;
    axios
      .get(url)
      .then((res) => {
        if (res.data.competencies) {
          setCompetencies(res.data.competencies);
          const selectedCompetency = res.data.competencies.find(
            (c: any) => c.competency_code === id
          );
        }
      })
      .catch(() => { });
    const foundDuplicate = navigatedCompetencies.findIndex(
      (el: CompetencyType) => el.competency_code === competencyCode
    );
    if (foundDuplicate !== -1) {
      const newArray = navigatedCompetencies.splice(0, foundDuplicate + 1);
      setNavigatedCompetencies(newArray);
    } else {
      if (findCompetency) {
        setNavigatedCompetencies([...navigatedCompetencies, findCompetency]);
      }
    }
  };
  function filterArrayElementByCode(code: string) {
    return competencies.filter((element) => {
      return element.competency_code === code;
    })[0];
  }
  const redirectCompetency = (e: any, id: string) => {
    e.preventDefault();
    navigate(`/view/competency/detail/${id}`);
  };

  const onImageChange = (e: any) => {
    const fileAsDataURL = window.URL.createObjectURL(e.target.files[0]);
    getHeightAndWidthFromDataUrl(fileAsDataURL).then((dimensions: any) => {
      if (
        dimensions.width > 335 &&
        dimensions.width < 347 &&
        dimensions.height > 389 &&
        dimensions.height < 401
      ) {
        setDimensionError(false);
        setImage({
          preview: URL.createObjectURL(e.target.files[0]),
          raw: e.target.files[0],
        });
        if (competency && competency.id !== "") {
          const data = new FormData();
          data.append("competency_code", competency.competency_code);
          data.append("icon", competency.graphics.icon);
          data.append("iconbg", competency.graphics.iconbg);
          data.append("bordercolor", competency.graphics.bordercolor);
          data.append("iconshadow", competency.graphics.iconshadow);
          data.append("image", e.target.files[0]);
          data.append("curriculum_version", version.version_number);
          updateCompetencyImage(data);
        }
      } else {
        setDimensionError(true);
      }
    });
  };
  const getHeightAndWidthFromDataUrl = (dataURL: any) =>
    new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        resolve({
          height: img.height,
          width: img.width,
        });
      };
      img.src = dataURL;
    });
  const updateCompetencyImage = (data: any) => {
    setLoading(true);
    // axios
    // .post("/competency/image", data)
    axios
      .post("/competency/image", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        setMessage("Updated competency image successfully");
        setIsSnackbarOpen(true);
        setLoading(false);
        fetchCompetency(competencyCode || "");
      })
      .catch(function (error) {
        setImage({ preview: "", raw: "" });
        if (error.response) {
          setMessage(
            error.response.data.error || "Failed to update competency image!"
          );
          setIsErrorOpen(true);
        } else if (error.request) {
          console.log(error.request);
        } else {
          setMessage(error.response.data.error);
          setIsErrorOpen(true);
        }
        setLoading(false);
      });
  };
  const checkLegacyVersions = (competency_code: string, version: number | undefined, e: any) => {
    e.preventDefault();
    e.stopPropagation();
    // handleSubmitOverview(onSubmitOverview)(e);

    if (!competency_code || !version) {
      return;
    }
    axios.get(`/competency/legacy-versions?competency_code=${competency_code}&curriculum_version=${version}`)
      .then((data: any) => {
        const legacyVersions = data?.data?.["legacy-versions"] ?? [];
        if (legacyVersions.length > 0) {
          setLegacyVersionsData(legacyVersions);
          setLegacyConfirmOpen(true);
        } else {
          // handleSubmitOverview(onSubmitOverview)(e);
        }
      })
      .catch(() => {
      });
  };
  const updateCompetency = async (data: any) => {
    setLoading(true);
    await axios
      .put("/competency/update", data)
      .then((res) => {
        setMessage("Updated competency successfully");
        setIsSnackbarOpen(true);
        setLoading(false);
        fetchCompetency(competencyCode || "");
        // navigate("/modify/competency");
        competency?.version_status === "Active Prime" && checkLegacyVersions(competency.competency_code, competency.curriculum_version, { preventDefault: () => { }, stopPropagation: () => { } });
      })
      .catch(function (error) {
        if (error.response) {
          setMessage(
            error.response.data.error || "Failed to update competency!"
          );
          setIsErrorOpen(true);
        } else if (error.request) {
          setIsErrorOpen(true);
          fetchCompetency(competencyCode || "");
          console.log(error.request);
        } else {
          setMessage(error.response.data.error);
          setIsErrorOpen(true);
        }
        setLoading(false);
        fetchCompetency(competencyCode || "");
      });
  };
  const onSkillClicked = () => {
    if (isModified) {
      setOpen(true);
    } else {
      setPageHeight("100px");
      setTab(1);
    }
  };
  return (
    <>
      <SnackBar
        isOpen={isSnackbarOpen}
        setOpen={setIsSnackbarOpen}
        message={message}
        type="success"
      />
      <SnackBar
        isOpen={isErrorOpen}
        setOpen={setIsErrorOpen}
        header="Error!"
        message={message}
        type="error"
      />
      <SnackBar
        isOpen={dimensionError}
        setOpen={setDimensionError}
        type="error"
        header="Wrong Dimensions"
        message="Make sure the competency card image dimensions are correct!"
      />
      <SearchCompetencies
        totalRequiredCredits={null}
        showNavigator={true}
        competency={competency}
        competencies={competencies}
        showPillar={false}
        mode="view"
        height={pageHeight}
        navigationData={navigatedCompetencies}
        defaultSearchText={competency?.competency_code || ""}
        onSearch={(keyword) => searchCompetency(keyword)}
        snackbarOpen={snackbarOpen}
        setSnackbarOpen={setSnackbarOpen}
      >
        {noDataMessage !== "" ? (
          <div
            style={{ color: "black", padding: "20px", background: "#fffbd9" }}
          >
            {noDataMessage}
          </div>
        ) : competency && competency.id !== "" ? (
          <CustomFlex
            style={{
              minHeight: "inherit",
              height: "100%",
              borderBottom: "none",
              alignItems: "flex-start",
              overflowY: "scroll",
              paddingTop: 0,
            }}
          >
            {!isMobile && competency.graphics && (
              <CustomGrow>
                <FlexBox direction="column">
                  <FlexGrow style={{ flexGrow: 0 }}>
                    <CustomBlock
                      style={{
                        marginRight: "40px",
                        marginLeft: "40px",
                        marginTop: "60px",
                        borderRadius: 5,
                      }}
                      backgroundColor={
                        competency.graphics.iconbg || theme.color.blueButton
                      }
                    >
                      <StyledImg
                        src={
                          image.preview !== ""
                            ? image.preview
                            : process.env.REACT_APP_IMG_URL +
                            competency.graphics.imgurl
                        }
                        alt=""
                      />
                      <MuiIcon
                        sx={{
                          color: "white",
                          padding: "6px",
                          background: competency.graphics.iconbg,
                          borderRadius: "100px",
                          fontSize: "27px",
                          position: "absolute",
                          bottom: "90px",
                          right: "80px",
                          boxShadow: competency.graphics.iconshadow,
                        }}
                      >
                        {competency.graphics.icon}
                      </MuiIcon>
                      <StyledText fontWeight="700">
                        {competency.title}
                      </StyledText>
                    </CustomBlock>
                  </FlexGrow>
                  <FlexGrow>
                    <label
                      style={{
                        cursor: "pointer",
                        color: "black",
                        padding: "12px",
                        border: "1px solid gray",
                        borderRadius: "8px",
                      }}
                      htmlFor="upload-button"
                    >
                      <>
                        <Icon
                          style={{ verticalAlign: "bottom" }}
                          name={"file_upload"}
                        ></Icon>
                        Upload Image
                      </>
                    </label>
                    <div style={{ marginTop: "14px", textAlign: "center" }}>
                      <StyledText
                        style={{ fontStyle: "italic" }}
                        textSize={TextSize.small}
                        color="gray"
                        fontWeight="400"
                      >
                        Width: 336-346px
                        <div>Height: 390-400px</div>
                      </StyledText>
                    </div>
                    <input
                      type="file"
                      id="upload-button"
                      accept="image/png"
                      style={{ display: "none" }}
                      onClick={(
                        e: React.MouseEvent<HTMLInputElement, MouseEvent>
                      ) => ((e.target as HTMLInputElement).value = "")}
                      onChange={onImageChange}
                    />
                  </FlexGrow>
                </FlexBox>
              </CustomGrow>
            )}
            <FlexGrow
              style={{
                borderLeft: `3px solid ${theme.color.lightBlueGray100}`,
                paddingLeft: 10,
                // maxHeight: "calc(100vh - 244px)",
                minHeight: "calc(100vh - 244px)",
              }}
            >
              <CustomFlex>
                <FlexGrow>
                  <Header>
                    [{competency.competency_code}] {competency.title}
                  </Header>
                  <span style={{ color: "#0300c4ff", fontWeight: "bold" }}>
                    {competency.program_name} - {competency.display_version}
                  </span>
                </FlexGrow>
                <TabGroup
                  style={{ borderBottom: "none", padding: "0", margin: "0" }}
                >
                  <TabItem
                    active={tab === 0}
                    onClick={() => {
                      setPageHeight("130px");
                      setTab(0);
                    }}
                  >
                    <Icon
                      name="home"
                      style={{ verticalAlign: "text-bottom" }}
                      size={2.5}
                      fixedWidth={false}
                    />{" "}
                    Overview
                  </TabItem>
                  <TabItem active={tab === 1} onClick={() => onSkillClicked()}>
                    <Icon
                      name="keyboard_double_arrow_up"
                      style={{ verticalAlign: "text-bottom" }}
                      size={2.5}
                      fixedWidth={false}
                    />{" "}
                    Skills
                  </TabItem>
                  {/* <TabItem active={tab === 2} onClick={() => setTab(2)}>
                    <Icon
                      name="grid_view"
                      style={{ verticalAlign: 'text-bottom' }}
                      size={2.5}
                      fixedWidth={false}
                    />{' '}
                    Courses
                  </TabItem> */}
                </TabGroup>
              </CustomFlex>
              {loading && <LoadingSpinner />}
              {tab === 0 && (
                <>
                  <CourseOverviewModify
                    competencyData={competency}
                    allCompetencies={competencies}
                    legacyVersionsData={legacyVersionsData}
                    setLegacyVersionsData={setLegacyVersionsData}
                    legacyConfirmOpen={legacyConfirmOpen}
                    setLegacyConfirmOpen={setLegacyConfirmOpen}
                    goBack={() => { }}
                    onSaveComplete={updateCompetency}
                    fetchParent={() => fetchCompetency(competencyCode)}
                  />
                </>
              )}
              {tab === 1 && (
                <>
                  <CourseSkillsModify
                    goBack={() => { }}
                    competencyData={competency}
                    code={competencyCode || ""}
                    onSaveComplete={() => { }}
                  />
                </>
              )}
              {tab === 2 && (
                <>
                  <TableComponent navHeight="265px" aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {courseColumns.map((column) => (
                          <StyledHeaderCell
                            key={column.id}
                            align={column.align}
                            backgroundColor={theme.color.lightBlueGray50}
                            color={theme.color.lightBlueGray800}
                            style={{ minWidth: column.minWidth }}
                          >
                            {column.label}
                          </StyledHeaderCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {competency.skills.map((row: any, index) => {
                        return (
                          <StyledTableRowNoHover
                            hover={false}
                            role="checkbox"
                            tabIndex={-1}
                            key={index}
                          >
                            {courseColumns.map((column) => {
                              const value = row[column.id];
                              if (column.id === "competencies") {
                                return (
                                  <StyledBodyCell
                                    key={column.id}
                                    align={column.align}
                                  >
                                    {competencies.map((elem) => (
                                      <FlexBox>
                                        <FlexGrow>
                                          <ALink
                                            href="#"
                                            onClick={(e) =>
                                              redirectCompetency(
                                                e,
                                                elem.competency_code
                                              )
                                            }
                                          >
                                            <Ul>
                                              <LiGradient
                                                style={{
                                                  background:
                                                    elem.graphics.iconbg,
                                                }}
                                              >
                                                [{elem.competency_code}]{" "}
                                                {elem.title}
                                              </LiGradient>
                                            </Ul>
                                          </ALink>
                                        </FlexGrow>
                                      </FlexBox>
                                    ))}
                                  </StyledBodyCell>
                                );
                              }
                              return (
                                <StyledBodyCell
                                  key={column.id}
                                  align={column.align}
                                >
                                  {column.format && typeof value === "number"
                                    ? column.format(value)
                                    : value}
                                </StyledBodyCell>
                              );
                            })}
                          </StyledTableRowNoHover>
                        );
                      })}
                    </TableBody>
                  </TableComponent>
                </>
              )}
            </FlexGrow>
          </CustomFlex>
        ) : (
          <LoadingSpinner />
        )}
      </SearchCompetencies>
    </>
  );
}
export default ModifyCompetencyDetail;
